import qwest from 'qwest';

import Timeline from '../models/timeline.jsx';

let CustomerTimelineApi = {
  getList(customerID, pageSize, pageIndex, ascending) {
    return new Promise((resolve, reject) => {
      qwest.get(`/Timeline/List?customerID=${customerID}&pageSize=${pageSize}&pageIndex=${pageIndex}&ascending=${ascending}`)
        .then((xhr, response) => {
          if (response.success) {
            let timeline = response.data.map(n => Timeline.fromApiFormat(n));

            resolve(timeline);
          } else {
            reject(response);
          }
        });
    });
  },
};

export default CustomerTimelineApi;
